/**
 * Created by 马荣钦 on 2016/1/21.
 */
angular.module('myZonePersonalInfoRouterModule', [])
    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider.state('front.myzone.personalinfo', {
            url: '/personalinfo',
            views: {
                'main@front.myzone': {
                    templateUrl: './myZone/personalInfo/index_tpl.html',
                    controller: 'myZonePersonalInfoCtrl'
                },
                'left@front.myzone.personalinfo': {
                    templateUrl: './myZone/personalInfo/left_tpl.html',
                    controller: 'myZonePersonalInfoLeftCtrl'
                },
                'footer@front.myzone.personalinfo': {
                    templateUrl: './footer_tpl.html'
                }
            }
        })
            .state('front.myzone.personalinfo.info', {
                url: '/personalinfoinfo',
                views: {
                    'main@front.myzone.personalinfo': {
                        templateUrl: './myZone/personalInfo/info/info_tpl.html',
                        controller: 'myZonePerInfoInfoCtrl'
                    }
                }
            })
            .state('front.myzone.personalinfo.changepwd', {
                url: '/changepwd',
                views: {
                    'main@front.myzone.personalinfo': {
                        templateUrl: './myZone/personalInfo/changePassword/changePassword_tpl.html',
                        controller: 'myZonePerInfoChangePwdCtrl'
                    }
                }
            })
            // 个人偏好设置
            .state('front.myzone.personalinfo.perferenceconfig', {
                url: '/perferenceconfig',
                views: {
                    'main@front.myzone.personalinfo': {
                        templateUrl: './myZone/personalInfo/preferencesConfig/perference_tpl.html',
                        controller: 'myZonePerPerferenceConfigCtrl'
                    }
                }
            })
            .state('front.myzone.personalinfo.persetting', {
                url: '/personalsetting',
                views: {
                    'main@front.myzone.personalinfo': {
                        templateUrl: './myZone/personalInfo/personalSetting/personalSetting_tpl.html',
                        controller: 'myZonePerInfoPerSettingCtrl'
                    }
                }
            })
            .state('front.myzone.personalinfo.forgetpw', {
                url: '/forgetpw',
                views: {
                    'main@front.myzone.personalinfo': {
                        templateUrl: './myZone/personalInfo/changePassword/forgetPassword/forgetPassword_tpl.html',
                        controller: 'myZonePerInfoForgetPwCtrl'
                    }
                }
            })
            .state('front.myzone.personalinfo.entermail', {
                url: '/forgetpw/entermail',
                views: {
                    'main@front.myzone.personalinfo': {
                        templateUrl: './myZone/personalInfo/changePassword/forgetPassword/enterEmail.html',
                        controller: 'myZonePerInfoForgetPwCtrl'
                    }
                }
            });
    }]);
